module.exports = __webpack_public_path__ + "static/media/road-solid_r.cc2b1ed6.svg";